// extracted by mini-css-extract-plugin
export var brand = "_3x-9";
export var compact = "_3x-6";
export var extraSmall = "_3x-7";
export var icon = "_3x-0";
export var large = "_3x-4";
export var light = "_3x-1";
export var medium = "_3x-5";
export var outline = "_3x-b";
export var primaryDark = "_3x-a";
export var primaryLight = "_3x-8";
export var primaryModern = "_3x-c";
export var success = "_3x-2";
export var successSolid = "_3x-3";